import { VendorActivityScreen } from "@/features/vendor/dashboard";

export default VendorActivityScreen;
